const processEnv = typeof process !== 'undefined' ? process.env : {};
const injectedEnv = window && window.injectedEnv ? window.injectedEnv : {};

const ENV = {
  /* Put defaults here */
  VUE_APP_OAUTH_GOOGLE_CLIENT_ID: false,
  VUE_APP_DISABLE_DETECTIONS: 'false',
  VUE_APP_LABEL_SET_SAMPLES_HIDE_ADVANCED_FILTERS: false,

  /* environment will override defaults here */
  ...processEnv,
  ...injectedEnv,

  /* Put overrides here */
};

window.ENV = ENV;

export default ENV;
